"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-p2p.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-p2p.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.P2PPaymentContextParty = exports.P2PPaymentContext = void 0;
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const savings_goal_1 = require("../common/savings-goal");
const transfer_request_status_1 = require("../common/transfer-request-status");
const protobufPackage = 'com.step.common.proto';
function createBaseP2PPaymentContext() {
    return {
        initiatedByUserId: '',
        from: undefined,
        to: undefined,
        scheduled: false,
        requestId: '',
        requestStatus: transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS,
        usesExternalAccount: false,
        reimburseTransactionId: '',
        transferAmount: undefined,
    };
}
exports.P2PPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.initiatedByUserId)) {
            message.initiatedByUserId = globalThis.String(object.initiatedByUserId);
        }
        if (isSet(object.from)) {
            message.from = exports.P2PPaymentContextParty.fromJSON(object.from);
        }
        if (isSet(object.to)) {
            message.to = exports.P2PPaymentContextParty.fromJSON(object.to);
        }
        if (isSet(object.scheduled)) {
            message.scheduled = globalThis.Boolean(object.scheduled);
        }
        if (isSet(object.requestId)) {
            message.requestId = globalThis.String(object.requestId);
        }
        if (isSet(object.requestStatus)) {
            message.requestStatus = (0, transfer_request_status_1.transferRequestStatusFromJSON)(object.requestStatus);
        }
        if (isSet(object.usesExternalAccount)) {
            message.usesExternalAccount = globalThis.Boolean(object.usesExternalAccount);
        }
        if (isSet(object.reimburseTransactionId)) {
            message.reimburseTransactionId = globalThis.String(object.reimburseTransactionId);
        }
        if (isSet(object.transferAmount)) {
            message.transferAmount = amount_1.Amount.fromJSON(object.transferAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.initiatedByUserId !== undefined && message.initiatedByUserId !== '') {
            obj.initiatedByUserId = message.initiatedByUserId;
        }
        if (message.from !== undefined) {
            obj.from = exports.P2PPaymentContextParty.toJSON(message.from);
        }
        if (message.to !== undefined) {
            obj.to = exports.P2PPaymentContextParty.toJSON(message.to);
        }
        if (message.scheduled !== undefined && message.scheduled !== false) {
            obj.scheduled = message.scheduled;
        }
        if (message.requestId !== undefined && message.requestId !== '') {
            obj.requestId = message.requestId;
        }
        if (message.requestStatus !== undefined &&
            message.requestStatus !== transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS) {
            obj.requestStatus = (0, transfer_request_status_1.transferRequestStatusToJSON)(message.requestStatus);
        }
        if (message.usesExternalAccount !== undefined && message.usesExternalAccount !== false) {
            obj.usesExternalAccount = message.usesExternalAccount;
        }
        if (message.reimburseTransactionId !== undefined && message.reimburseTransactionId !== '') {
            obj.reimburseTransactionId = message.reimburseTransactionId;
        }
        if (message.transferAmount !== undefined) {
            obj.transferAmount = amount_1.Amount.toJSON(message.transferAmount);
        }
        return obj;
    },
    create(base) {
        return exports.P2PPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseP2PPaymentContext();
        message.initiatedByUserId = object.initiatedByUserId ?? '';
        message.from = (object.from !== undefined && object.from !== null)
            ? exports.P2PPaymentContextParty.fromPartial(object.from)
            : undefined;
        message.to = (object.to !== undefined && object.to !== null)
            ? exports.P2PPaymentContextParty.fromPartial(object.to)
            : undefined;
        message.scheduled = object.scheduled ?? false;
        message.requestId = object.requestId ?? '';
        message.requestStatus = object.requestStatus ?? transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS;
        message.usesExternalAccount = object.usesExternalAccount ?? false;
        message.reimburseTransactionId = object.reimburseTransactionId ?? '';
        message.transferAmount = (object.transferAmount !== undefined && object.transferAmount !== null)
            ? amount_1.Amount.fromPartial(object.transferAmount)
            : undefined;
        return message;
    },
};
function createBaseP2PPaymentContextParty() {
    return {
        userId: '',
        accountId: '',
        savingsGoal: undefined,
        name: '',
        aliases: [],
        pictureUrl: '',
    };
}
exports.P2PPaymentContextParty = {
    fromJSON(object) {
        const message = {
            aliases: globalThis.Array.isArray(object?.aliases)
                ? object.aliases.map((e) => alias_1.Alias.fromJSON(e))
                : [],
        };
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        if (isSet(object.savingsGoal)) {
            message.savingsGoal = savings_goal_1.SavingsGoal.fromJSON(object.savingsGoal);
        }
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = savings_goal_1.SavingsGoal.toJSON(message.savingsGoal);
        }
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.aliases?.length) {
            obj.aliases = message.aliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        return obj;
    },
    create(base) {
        return exports.P2PPaymentContextParty.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseP2PPaymentContextParty();
        message.userId = object.userId ?? '';
        message.accountId = object.accountId ?? '';
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? savings_goal_1.SavingsGoal.fromPartial(object.savingsGoal)
            : undefined;
        message.name = object.name ?? '';
        message.aliases = object.aliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.pictureUrl = object.pictureUrl ?? '';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-p2p.js.map